import { IRegion } from '../../../../node/types/region';
import { TReduxActions } from '../../actions';
import { ERegionActionType } from '../../actions/region';

export function regionReducer(state: IRegion | null = null, action: TReduxActions): IRegion | null {
  switch (action.type) {
    case ERegionActionType.Changed:
      if (!action.payload) {
        return null;
      }

      return {
        ...action.payload,
      };
  }

  return state;
}
